import { render, staticRenderFns } from "./CitiesList.vue?vue&type=template&id=4f615c1d&scoped=true"
import script from "./CitiesList.vue?vue&type=script&lang=js"
export * from "./CitiesList.vue?vue&type=script&lang=js"
import style0 from "./CitiesList.vue?vue&type=style&index=0&id=4f615c1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f615c1d",
  null
  
)

export default component.exports